import axios from '../../../../utils/request';

function GET_LIST(params) {
    return axios.get("/file/Manage/index",{
        params: {
            page:params
        }
    } )
}
function SUBMIT_ADD(params) {
    return  axios.post("/file/Manage/addPost",{...params} )
}
function EDIT_DATA(params) {
    return  axios.post("/file/Manage/edit",  {
            ...params
        }  )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/file/Manage/editPost",{...params} )
}
function DELE(params) {
    return  axios.get("/file/Manage/delete",{
        params: {
            ids:params
        }
    } )
}
function GET_FORM_LIST(params) {
    return  axios.post("/inquiry/AInquiryRuleSetting/add",{...params} )
}

export default {
    GET_LIST,
    SUBMIT_ADD,
    EDIT_DATA,
    SUBMIT_EDIT,
    DELE,GET_FORM_LIST
};
